<template>
    <div v-if="formId">
        <zipcode-input
            :inputId="formId + '_zipcode'"
            :inputLbl="lblShipping.zipcode"
            :inputMinLength="5"
            :inputMaxLength="5"
            :isFirstSave="isFirstSave"
            :isShowErrorLbl="isShowErrorLbl"
            :errorInfo="zipcodeError"
            v-model="address.zipcode"
            @onZipcodeChange="onZipcodeChange()"
            ></zipcode-input>
        <label class="bi-lbl"
            :for="formId">{{lblShipping.province.name}}</label>
        <div class="bi-com bi-dropdown">
            <b-dropdown
                :inputId="formId + '_province'"
                class="bi-ddl"
                variant="bi-ddl"
                menu-class="bi-ddl-menu"
                :class="{'bi-error': !isFirstSave && isShowErrorLbl && !provinceError.isValid}"
                :text="address.provinceName || lblShipping.province.placeholder">
                <b-dropdown-item
                    :disabled="true">
                    {{lblShipping.province.placeholder}}
                </b-dropdown-item>
                <b-dropdown-item
                    v-for="(province, index) in arrFilteredProvince"
                    :key="index" @click="selectProvince(province)">
                    {{ locale == 1033 ? province.provinceNameEN : province.provinceName }}
                </b-dropdown-item>
            </b-dropdown>
            <div class="bi-lbl-error"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !provinceError.isValid">{{provinceError.msg}}</div>
        </div>
        <label class="bi-lbl"
            :for="formId">{{lblShipping.district.name}}</label>
        <div class="bi-com bi-dropdown">
            <b-dropdown
                :inputId="formId + '_district'"
                class="bi-ddl"
                variant="bi-ddl"
                menu-class="bi-ddl-menu"
                :class="{'bi-error': !isFirstSave && isShowErrorLbl && !districtError.isValid}"
                :text="address.districtName || lblShipping.district.placeholder">
                <b-dropdown-item
                    :disabled="true">
                    {{lblShipping.district.placeholder}}
                </b-dropdown-item>
                <b-dropdown-item
                    v-for="(district, index) in arrFilteredDistrict"
                    :key="index" @click="selectDistrict(district)">
                    {{ locale == 1033 ? district.districtNameEN : district.districtName }}
                </b-dropdown-item>
            </b-dropdown>
            <div class="bi-lbl-error"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !districtError.isValid">{{districtError.msg}}</div>
        </div>
        <label class="bi-lbl"
            :for="formId">{{lblShipping.subdistrict.name}}</label>
        <div class="bi-com bi-dropdown">
            <b-dropdown
                :inputId="formId + '_subdistrict'"
                class="bi-ddl"
                variant="bi-ddl"
                menu-class="bi-ddl-menu"
                :class="{'bi-error': !isFirstSave && isShowErrorLbl && !subDistrictError.isValid}"
                :text="address.subDistrictName || lblShipping.subdistrict.placeholder">
                <b-dropdown-item
                    :disabled="true">
                    {{lblShipping.subdistrict.placeholder}}
                </b-dropdown-item>
                <b-dropdown-item
                    v-for="(subdistrict, index) in arrFilteredSubDistrict"
                    :key="index" @click="selectSubDistrict(subdistrict)">
                    {{ locale == 1033 ? subdistrict.subdistrictNameEN : subdistrict.subdistrictName }}
                </b-dropdown-item>
            </b-dropdown>
            <div class="bi-lbl-error"
                v-if="isShowErrorLbl"
                v-show="!isFirstSave && !subDistrictError.isValid">{{subDistrictError.msg}}</div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
import BzbsAddress from '@/service/BzbsAddress.js';
import Locale from '@/helper/locale/locale.js';
import ZipcodeInput from '@/components/common/input/Zipcode.vue';
/**
 * @property {object} address (required) Address data model.
 * @property {string} formId (optional) Text for id.
 * @property {object} lblShipping (required) Text for component.
 * @property {object} isFirstSave (required) Show/Hide Error.
 * @property {object} zipcodeError (required) Validate status.
 * @property {object} provinceError (required) Validate status.
 * @property {object} districtError (required) Validate status.
 * @property {object} subDistrictError (required) Validate status.
 *
 * @property {object} busModal (required) Control modal.
 */
export default {
    name: 'FormAddressDropdown',
    components: {
        ZipcodeInput
    },
    props: {
        lblShipping: Object,
        formId: String,
        address: Object,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        zipcodeError: Object,
        provinceError: Object,
        districtError: Object,
        subDistrictError: Object,

        busModel: Object
    },
    data: function () {
        return {
            locale: Locale.getLocaleCode(),
            arrProvince: [],
            arrDistrict: [],
            arrSubDistrict: [],
            arrFilteredProvince: [],
            arrFilteredDistrict: [],
            arrFilteredSubDistrict: [],
        };
    },
    mounted: function () {
        //Validate zipcode and Setup select field.
        if(!this.address) return;
        if(Vue.validator.validateZipCode(this.address.zipcode)) {
            this.onZipcodeChange();
        }

        this.validateSelect();
    },
    methods: {
        //Event
        selectProvince: function (province) {
            if(!province) return;

            this.filterDistrictByProvince(province);
        },
        selectDistrict: function (district) {
            if(!district) return;

            this.filterSubDistrictByDistrict(district);
        },
        selectSubDistrict: function (subdistrict) {
            if(!subdistrict) return;

            this.address.subDistrictCode = subdistrict.subdistrictCode;
            this.address.subDistrictName = this.locale == 1033
                ? subdistrict.subdistrictNameEN
                : subdistrict.subdistrictName;
        },
        onZipcodeChange: function () {
            if (Util.validateZipCode(this.address.zipcode)) {
                BzbsAddress.apiGetProvinceFilterByZipcode(this.address.zipcode).then((data) => {
                    //Reset array.
                    this.resetArrAddress();
                    //Setup address array.
                    this.arrProvince = data.listProvince;
                    this.arrDistrict = data.listDistrict;
                    this.arrSubDistrict = data.listSubDistrict;
                    this.initialAddressDDL();
                }).catch((error) => {
                    console.log(error);
                });
            } else {
                this.resetSelectValue();
                this.resetArrAddress();
                this.validateSelect();
            }
        },
        //Method
        initialAddressDDL: function () {
            if(this.arrProvince.length === 0) return;

            //Setup province data.
            var self = this;
            var province;
            if(!this.address.provinceCode) {
                province = this.arrProvince;
            } else {
                province = this.arrProvince.filter(function (item) {
                    return (item.provinceCode == self.address.provinceCode);
                });
            }
            this.arrFilteredProvince.push.apply(this.arrFilteredProvince, this.arrProvince);

            //Fill data.
            this.address.provinceCode = province.provinceCode;
            this.address.provinceName = this.locale == 1033
                    ? province.provinceNameEN
                    : province.provinceName;
            this.filterDistrictByProvince(province[0]);
        },
        resetSelectValue: function () {
            this.address.provinceCode = null;
            this.address.districtCode = null;
            this.address.subDistrictCode = null;
            this.address.provinceName = '';
            this.address.districtName = '';
            this.address.subDistrictName = '';
        },
        resetArrAddress: function () {
            this.arrProvince.length = 0;
            this.arrDistrict.length = 0;
            this.arrSubDistrict.length = 0;
            this.arrFilteredProvince.length = 0;
            this.arrFilteredDistrict.length = 0;
            this.arrFilteredSubDistrict.length = 0;
        },
        validateSelect: function () {
            if(this.address.provinceCode) {
                this.provinceError.isValid = true;
                this.provinceError.msg = '';
            } else {
                this.provinceError.isValid = false;
                this.provinceError.msg = this.lblShipping.province.required;
            }

            if(this.address.districtCode) {
                this.districtError.isValid = true;
                this.districtError.msg = '';
            } else {
                this.districtError.isValid = false;
                this.districtError.msg = this.lblShipping.district.required;
            }

            if(this.address.subDistrictCode) {
                this.subDistrictError.isValid = true;
                this.subDistrictError.msg = '';
            } else {
                this.subDistrictError.isValid = false;
                this.subDistrictError.msg = this.lblShipping.subdistrict.required;
            }

            this.$emit('input');
        },
        filterDistrictByProvince: function (province) {
            //Fill data.
            this.address.provinceCode = province.provinceCode;
            this.address.provinceName = this.locale == 1033
                    ? province.provinceNameEN
                    : province.provinceName;
            //Setup district data.
            var allfilteredDistrict = this.arrDistrict.filter(function (item) {
                return (item.provinceCode == province.provinceCode);
            });
            this.arrFilteredDistrict.push.apply(this.arrFilteredDistrict, allfilteredDistrict);

            //Set selected item.
            var self = this;
            var district;
            var filteredByDistrictCode;
            if(!this.address.districtCode) {
                district = allfilteredDistrict[0]
            } else {
                filteredByDistrictCode = this.arrFilteredDistrict.filter(function (item) {
                    return (item.districtCode == self.address.districtCode);
                });

                district = filteredByDistrictCode && filteredByDistrictCode.length > 0
                    ? filteredByDistrictCode[0]
                    : allfilteredDistrict[0];
            }

            //Filter subdistrict.
            this.filterSubDistrictByDistrict(district);
        },
        filterSubDistrictByDistrict: function (district) {
            //Fill data.
            this.address.districtCode = district.districtCode;
            this.address.districtName = this.locale == 1033
                    ? district.districtNameEN
                    : district.districtName;
            //Setup subdistrict data.
            var allfilteredSubDistrict = this.arrSubDistrict.filter(function (item) {
                return (item.districtCode == district.districtCode);
            });
            this.arrFilteredSubDistrict.push.apply(this.arrFilteredSubDistrict, allfilteredSubDistrict);

            //Set selected item.
            var self = this;
            var subdistrict;
            var filteredBySubDistrictCode;
            if(!this.address.subDistrictCode) {
                subdistrict = allfilteredSubDistrict[0]
            } else {
                filteredBySubDistrictCode = this.arrFilteredSubDistrict.filter(function (item) {
                    return (item.subdistrictCode == self.address.subDistrictCode);
                });

                subdistrict = filteredBySubDistrictCode && filteredBySubDistrictCode.length > 0
                    ? filteredBySubDistrictCode[0]
                    : allfilteredSubDistrict[0];
            }

            //Fill data.
            this.address.subDistrictCode = subdistrict.subdistrictCode;
            this.address.subDistrictName = this.locale == 1033
                    ? subdistrict.subdistrictNameEN
                    : subdistrict.subdistrictName;

            this.validateSelect();
        },
    }
}
</script>
<style lang="scss">
@import "@/style/base/component/baseinput.scss";
</style>
